const USER_ROLES = {
  manager: 'manager',
  warehousePersonnel: 'warehouse_personnel',
  cashiers: 'cashiers',
};

export default USER_ROLES;
